<template>
  <div class="update">
    <div class="card mb-3" v-bind:class="[isCurrent ? ' border-primary' : '']">
      <div class="card-header" >
        <h2 style="margin:0;">{{ this.number }}</h2>
      </div>
      <div class="card-body" >
        <div v-for="group in groups" :key="group.header">
          <h5 v-if="group.header" class="card-title">{{ group.header }}</h5>
          <ul>
            <li v-for="note in group.notes" :key="note" class="card-text">{{ note }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    number: String,
    groups: Array,
  },
  data(){
        return {
            version: process.env.VUE_APP_VERSION
        };
  },
  computed:{
    isCurrent()
    {
      return this.number == this.version;
    }
  }
};
</script>
